import { navigationURL } from './endpoints';
function NavigationService({
  access_token
}) {
  const fetchWithAuth = function (url, options = {}) {
    options = {
      ...options,
      headers: {
        ...(options.headers || {}),
        'authorization': `Bearer ${access_token}`
      }
    };
    return fetch(url, options);
  };
  async function getMenu(type) {
    const res = await fetchWithAuth(`${navigationURL}/menus/${encodeURIComponent(type)}/person`);
    const data = await res.json();
    if (res.ok) {
      return data;
    } else {
      throw data;
    }
  }
  return {
    getMenu
  };
}
export default NavigationService;
//# sourceMappingURL=navigation-service.js.map